import { render, staticRenderFns } from "./ThePagination.vue?vue&type=template&id=2067e19c&scoped=true&"
import script from "./ThePagination.vue?vue&type=script&lang=js&"
export * from "./ThePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2067e19c",
  null
  
)

export default component.exports